(function() {
    const initCardsLayoutBlocks = () => {
        const blocks_CardsLayout = document.querySelectorAll('.js-cards-layout');

        blocks_CardsLayout.forEach(block => {
            handleBreakpointChange(block);

            Breakpoints.addListener('tablet', function() {
                handleBreakpointChange(block);
            });
        });
    };

    const handleBreakpointChange = (block) => {
        if (Breakpoints.isMax('tablet')) {
            initSwiper(block);
        } else {

            destroySwiper(block);
        }
    };

    const initSwiper = (block) => {
        if (!block?.swiper) {
            new Swiper(block, {
                slidesPerView: 'auto',
                centeredSlides: false,
                freeMode: false,
                spaceBetween: 5,
                grabCursor: true,
            });
        }
    };

    const destroySwiper = (block) => {
        if (block?.swiper) {
            block.swiper.destroy(true, true);
        }
    };

    initCardsLayoutBlocks();
})();